import type { StripeProducts } from '@racemap/sdk/schema/billing/StripeProducts';
import { useCallback } from 'react';
import type { Price } from '../../components/CostCalculator/getProductPriceFactory';
import { useGetProductPrice } from './useGetProductPrice';

export function useGetProductPricePerUnit({
  isReseller,
}: { isReseller?: boolean } = {}): (
  product: StripeProducts,
  tierIndex?: number,
) => Price | undefined {
  const getProductPrice = useGetProductPrice({ isReseller });

  return useCallback(
    (product: StripeProducts, tierIndex?: number) => getProductPrice?.(product, 1, tierIndex),
    [getProductPrice],
  );
}
